import { ReactNode } from "react";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { BackButton, PageTitleWrapper } from "@/basic/components";
import { StickyLayout } from "@/basic/layouts";

import styles from "./styles.module.scss";

export interface ListLayoutProps {
  readonly children: ReactNode;
  readonly pageTitle: ReactNode;
  readonly pageTitleChildren?: ReactNode;
  readonly testId?: string;
  readonly backButtonPath: string;
  readonly backButtonParams: string;
}

export const ListLayout = ({ children, pageTitle, pageTitleChildren, testId, backButtonPath, backButtonParams }: ListLayoutProps) => {
  return (
    <StickyLayout testId={testId}>
      <div className={styles["ListContentWrapper"]}>
        <Shelf>
          <BackButton path={backButtonPath} params={backButtonParams} />
          <Shelf.Spacer />
        </Shelf>

        <PageTitleWrapper title={pageTitle}>{pageTitleChildren}</PageTitleWrapper>

        {children}
      </div>
    </StickyLayout>
  );
};
